/* eslint-disable prefer-template */
import React, { useCallback } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons'
import { validate } from '../../../utils/validators'

const RadioButton = ({
  id,
  name,
  label,
  options = [],
  className = '',
  isError = false,
  errorMessage = 'Invalid value!!!',
  initialValue = '',
  onChange = () => {},
  validators = [],
  info,
}) => {
  const onChangeHandler = useCallback(
    (e) => {
      const value = e.target.value
      const isValid = validate(value, validators)
      onChange(id, value, isValid)
    },
    [id, onChange, validators]
  )

  return (
    <div className={'mb-3 w-full ' + className}>
      <div className="mb-1.5">
        <label className="font-medium text-base whitespace-nowrap" htmlFor={name}>
          {`${label}`}
          {info && (
            <span className="relative ml-1 group cursor-pointer">
              <FontAwesomeIcon icon={faCircleInfo} className="text-gray-400" />
              <span className="absolute right-1/2 left-1/2 bottom-0 flex-col items-center hidden mb-6 group-hover:flex">
                <span className="w-60 relative rounded-md z-10 py-3 px-4 bg-gray-100 text-sm whitespace-normal text-labelColor">
                  {info}
                </span>
                <span className="w-4 h-4 -mt-3 rotate-45 bg-gray-100"></span>
              </span>
            </span>
          )}
        </label>
      </div>
      <div className="">
        {options.map((option) => (
          <label
            key={option.value}
            className="flex items-center mr-3"
            style={{
              verticalAlign: 'middle',
              marginRight: '15px',
              display: 'inline-flex',
            }}
          >
            <input
              type="radio"
              id={id}
              // name={name}
              value={option.value}
              checked={initialValue === option.value}
              onChange={onChangeHandler}
              style={{
                marginRight: '5px',
              }}
            />
            <span className="ml-2">{option.label}</span>
          </label>
        ))}
      </div>
      {isError && (
        <span className="text-warning text-sm">
          <FontAwesomeIcon icon={faCircleInfo} className="" /> {errorMessage}
        </span>
      )}
    </div>
  )
}

export default RadioButton
